import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import { DeviceType, useDeviceType } from '@library/dom'

import { Carousel, type CarouselProps } from '../../EndlessVarietySection/Carousel'
import { LandingPageContentSections } from '../../../tracking'
import { RECIPE_VIDEOS } from '../config'
import { CWCRecipeVideoCard } from './CWCRecipeVideoCard'

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.HOMEPAGE_REVIEWS,
}

export const CWCRecipeVideosCarousel = () => {
  const deviceType = useDeviceType()
  const isDesktopDevice = deviceType === DeviceType.DESKTOP

  let carouselOptions: CarouselProps['options']
  if (isDesktopDevice) {
    carouselOptions = { align: 'center' as const, containScroll: 'trimSnaps', loop: false }
  } else {
    carouselOptions = { align: 'start' as const, loop: false }
  }

  return (
    <Box data-testid="recipe-videos-carousel">
      <Carousel
        carouselAreaLabel="recipeVideosCarousel"
        options={carouselOptions}
        slidePaddingH={2}
        slidePaddingV={1}
        showNavButtons={false}
        centerSlidesWhenNotScrollable={isDesktopDevice}
        snowplowTrackingProperties={propertiesForTracking}
      >
        {RECIPE_VIDEOS.map(({ videoURL, recipeName, rating, tile }) => (
          // The card's 50px-blur drop shadow stays faintly visible ~73px below it; the shared
          // Carousel clips overflow on both axes, so pad the slide's bottom generously to keep the
          // shadow's full gradual fade from being cut. The section re-balances the following gap.
          <Box key={recipeName} paddingBottom={20}>
            <CWCRecipeVideoCard
              videoURL={videoURL}
              recipeName={recipeName}
              rating={rating}
              tile={tile}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
